import {AsyncPage, Empty} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {Page} from 'Core/models/Page';
import {pipe} from 'fp-ts/lib/pipeable';
import {fold as foldOption, fromNullable} from 'fp-ts/lib/Option';
import {constant} from 'fp-ts/lib/function';
import {PageFetchAction} from 'Shared/utilities/sagaApiGenerators';
import {Client} from 'GenericTexting/models/Client';

export enum ClientActionType {
  GET_CLIENTS = 'client/GET_CLIENTS',
  CHANGE_CLIENTS = 'client/CHANGE_CLIENTS',
  CHANGE_CLIENTS_FILTER = 'client/CHANGE_CLIENTS_FILTER',
}

export const DefaultClientFilters: ClientFilters = {
  pageSize: 0,
  identifier: '',
  clientName: '',
};

export type ClientFilters = {
  pageSize?: number;
  identifier: string;
  clientName: string;
};

export const searchClients = (pageOption?: Page<Client>, filter?: ClientFilters) => {
  const payload = pipe(
    fromNullable(pageOption),
    foldOption(constant(PageFetchAction.Initial({filter})), page =>
      PageFetchAction.Additional({existingPage: page, filter})
    )
  );
  return createAction(ClientActionType.GET_CLIENTS, payload);
};

export const changeClients = (clientReports: AsyncPage<Page<Client>>) =>
  createAction(ClientActionType.CHANGE_CLIENTS, clientReports);

export const changeClientsFilters = (filters: ClientFilters) =>
  createAction(ClientActionType.CHANGE_CLIENTS_FILTER, {filters});

type ClientState = {
  clientPage: AsyncPage<Page<Client>>;
  filter: ClientFilters;
};

export const DEFAULT_STATE: ClientState = {
  clientPage: new Empty(),
  filter: DefaultClientFilters,
};

type ClientAction =
  | ReturnType<typeof searchClients>
  | ReturnType<typeof changeClients>
  | ReturnType<typeof changeClientsFilters>;

export default (state: ClientState = DEFAULT_STATE, action: ClientAction): ClientState => {
  switch (action.type) {
    case ClientActionType.CHANGE_CLIENTS:
      return {
        ...state,
        clientPage: action.payload,
      };
    case ClientActionType.CHANGE_CLIENTS_FILTER:
      return {
        ...state,
        filter: action.payload.filters,
      };
    default:
      return state;
  }
};
